import { Icon } from "@iconify/react";
import { useTheme, Avatar } from "@/design-system";
import { useContext, useState } from "react";
import AuthContext from "../../contexts/AuthContext";
import { usePWAInstallPrompt } from "../../common/usePWAInstallPrompt";
import InstallPrompt from "../InstallPrompt";
import "./DesktopHeader.css";

const DesktopHeader = ({
  eventName,
  eventDate,
  onShareClick,
  onHomeClick,
  onAddEventClick,
  onProfileClick,
  isDesktop,
}) => {
  const { theme, toggleTheme } = useTheme();
  const Context = useContext(AuthContext);
  const { showInstallPrompt, isIOSDevice, isAppInstalled } = usePWAInstallPrompt();
  const [installPromptOpen, setInstallPromptOpen] = useState(false);

  const user = Context?.state?.user?.attributes || {};
  const userName = user.name || user.email?.split("@")[0] || "User";
  const userPicture = user.picture;

  // Format date helper
  const formatEventDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleAddToHomeScreen = () => {
    if (isIOSDevice) {
      // For iOS, show the install prompt with instructions
      setInstallPromptOpen(true);
    } else {
      // For Android/Chrome, trigger the native install prompt
      if (showInstallPrompt) {
        showInstallPrompt();
      }
    }
  };

  const handleInstallPromptClose = () => {
    setInstallPromptOpen(false);
  };

  if (!isDesktop) {
    return null;
  }

  return (
    <header className="desktop-header">
      <div className="desktop-header__left">
        <h1 className="desktop-header__event-name">{eventName || "Event"}</h1>
        <p className="desktop-header__event-date">{formatEventDate(eventDate)}</p>
      </div>
      <div className="desktop-header__right">
        <button
          type="button"
          className="desktop-header__btn desktop-header__btn--share"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (onShareClick) {
              onShareClick(e);
            }
          }}
        >
          Share Event
          <span className="desktop-header__share-icon">
            <Icon icon="mynaui:share" width="14" height="14" />
          </span>
        </button>
        <button type="button" className="desktop-header__btn" onClick={onHomeClick}>
          <Icon icon="hugeicons:home-03" width="18" height="18" />
          Home
        </button>
        <button type="button" className="desktop-header__btn" onClick={onAddEventClick}>
          <Icon icon="icon-park-outline:add-one" width="18" height="18" />
          Add Event
        </button>
        {!isAppInstalled && (
          <button type="button" className="desktop-header__btn" onClick={handleAddToHomeScreen}>
            <Icon icon="material-symbols:add-to-home-screen-outline" width="18" height="18" />
            Install App
          </button>
        )}
        <button type="button" className="desktop-header__btn desktop-header__btn--icon" onClick={toggleTheme}>
          <Icon
            icon={theme === "dark" ? "mdi:weather-sunny" : "mdi:weather-night"}
            width="18"
            height="18"
            color="currentColor"
            style={{ display: 'block' }}
          />
        </button>
        <Avatar
          src={userPicture}
          name={userName}
          size={36}
          onClick={onProfileClick}
        />
      </div>

      {/* Install Prompt for iOS instructions */}
      {installPromptOpen && (
        <InstallPrompt
          onInstall={showInstallPrompt}
          isIOSDevice={isIOSDevice}
          isVisible={true}
          showIOSInstructionsDirectly={isIOSDevice}
          onClose={handleInstallPromptClose}
        />
      )}
    </header>
  );
};

export default DesktopHeader;

